module.exports = __webpack_public_path__ + "static/media/logo_clinicamassanassa.7247199b.png";